import { environment } from '@environment';

const BASE_URL = `${environment.cloudinaryURL}/travel/shared/trip-types-interests/`;
export const ICONS = [
  {
    name: 'arts-culture',
    link: `${BASE_URL}arts-culture.svg`,
  },
  {
    name: 'fashion-shopping',
    link: `${BASE_URL}fashion-shopping.svg`,
  },
  {
    name: 'food-wine',
    link: `${BASE_URL}food-wine.svg`,
  },
  {
    name: 'health-wellness',
    link: `${BASE_URL}health-wellness.svg`,
  },
  {
    name: 'nature-outdoors',
    link: `${BASE_URL}nature-outdoors.svg`,
  },
  {
    name: 'sports-adventure',
    link: `${BASE_URL}sports-adventure.svg`,
  },
  {
    name: 'couple',
    link: `${BASE_URL}couple.svg`,
  },
  {
    name: 'family',
    link: `${BASE_URL}family.svg`,
  },
  {
    name: 'friends',
    link: `${BASE_URL}friends.svg`,
  },
  {
    name: 'solo',
    link: `${BASE_URL}solo.svg`,
  },
  {
    name: 'business',
    link: `${BASE_URL}business.svg`,
  },
];
